// extracted by mini-css-extract-plugin
module.exports = {"label":"styles-module__label___1vriu"};